"use client"

import { Suspense } from 'react'
import LoginForm from './components/LoginForm'
import AuthMarketingPane from '@/components/auth/AuthMarketingPane'
import LanguageSwitcher from '@/components/layout/TopNavigationBar/components/Languages'
import styles from './login.module.css'

const LoginPage = () => {
  return (
    <div className={styles.splitLayout}>
      <div className={styles.formPane}>
        <div className={styles.loginFormContainer}>
          <div className={`${styles.mobileTopBar} d-lg-none`}>
            <LanguageSwitcher variant="login" />
          </div>
          <div className="d-none d-lg-flex justify-content-end mb-3">
            <LanguageSwitcher variant="login" />
          </div>
          <Suspense fallback={<div className="text-center py-4">Loading…</div>}>
            <LoginForm />
          </Suspense>
        </div>
      </div>
      <AuthMarketingPane />
    </div>
  )
}

export default LoginPage